var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 16,
    height: 16,
    "aria-hidden": "true",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487 0c-13.8 0-25 11.2-25 25v462c0 13.8 11.2 25 25 25s25-11.2 25-25V25c0-13.8-11.2-25-25-25M377 231H85.4l42.2-42.2c9.8-9.8 9.8-25.6 0-35.4s-25.6-9.8-35.4 0L7.3 238.3c-9.8 9.8-9.8 25.6 0 35.4l84.9 84.9c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L85.4 281H377c13.8 0 25-11.2 25-25s-11.2-25-25-25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.ae6ad42b83e67a1d7102c0e17eaa14a9.svg";
export { ForwardRef as ReactComponent };